module.exports = __webpack_public_path__ + "media/site/images/case_studies/ekanban/solution3_1-52911d465c7f7311734a9f3345ad4497.png";